import React from 'react';

const About = () => (
  <section id="about" className="g-py-75">
    <div className="container">
      <div className="row d-flex align-items-lg-center flex-wrap g-mb-60 g-mb-0--lg">
        <div className="col-md-6 col-lg-8">
          <img
            className="img-fluid rounded"
            src="/images/togetherAgain.jpg"
            alt="Bishop K.J. Brown"
          />
        </div>

        <div className="col-md-6 col-lg-4">
          <div className="g-mt-minus-30 g-mt-0--md g-ml-minus-100--lg">
            <div className="g-mb-20">
              <h2 className="g-color-black g-font-weight-600 g-font-size-25 g-font-size-35--lg g-line-height-1_2 mb-4">
                Welcome
                <br />
                Building Winning Lives
              </h2>

              <p className="g-font-size-16">
                Bishop K.J. Brown is the founder of Bishop K.J. Brown Ministries.
              </p>

              <p className="g-font-size-14">
                He has been in ministry for over 30 years and believes that practical,
                purposeful teaching and preaching build winning Christian lives. He is
                the founding pastor of Zion Tabernacle Church, Executive Director of
                Sparrow Ministries, founder of the Christian Sexual Integrity Movement
                (C-SIM), and President and founder of Bishop K.J. Brown Ministries.
                His life slogan is:&nbsp;
                <em>
                  “Be blessed, not stressed. Be safe, be smart, and remember—the Lord
                  wants you to win!”
                </em>
                &nbsp;He sincerely believes that people want to live better but often
                don&apos;t know how to apply the principles of Scripture as their guide.
              </p>

              <p className="g-font-size-14">
                All of the ministries of Bishop K.J. Brown Ministries have the goal of
                being a source of strength to the Body of Christ. Bishop Brown has
                spent his life helping people and sharing the gospel. The Lord has
                anointed him to preach, teach, and counsel using the Word of God as
                the basis and guide. He is a loving father of two young ladies and has
                been married to the love of his life for over 32 years. His life
                mission is to be the best husband, father, and vessel of God that he
                can be through God&apos;s strength.
              </p>

              <p className="g-font-size-14">
                He lives with the promise that we, as children of God, are “blessed and
                followed by favor.” “Blessed and followed by favor” is a phrase he has
                used for years and even wrote a song around those words. He believes
                and expects favor. “Building Winning Lives” is the church motto of Zion
                Tabernacle Church and the motto of every ministry division of Bishop
                K.J. Brown Ministries.
              </p>

              <p className="g-font-size-14">
                In His Service &amp; For His Glory
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;

  